import { Breadcrumbs, Typography, Link, LinkProps } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

const breadcrumbNameMap: { [key: string]: string } = {
  "/users": "Users",
  "/clients": "Clients",
  "/inspection-firms": "Inspections Firm",
  "/myprofile": "My Profile",
  "/roles-permissions": "Roles & Permissions",
  "/form-templates": "Form Templates",
  "/orders": "Orders",
  "/all-orders": "All Orders",
  "/created": "Created",
  "/validation": "Validation",
  "/assign": "Assign",
  "/accepted": "Accepted",
  "/qc-review": "QC Review",
  "/issues": "Issues",
  "/on-hold": "On Hold",
  "/closed": "Closed",
  "/invoicing": "Invoicing",
  "/billing": "Billing",
  "/my-organization": "My Organization",
  "/in-progress": "In Progress",
  "/submitted": "Submitted",
};

interface LinkRouterProps extends LinkProps {
  to: string | number;
  replace?: boolean;
  state?: any;
}

function LinkRouter(props: LinkRouterProps) {
  return <Link sx={{ textTransform: "capitalize" }} {...props} component={RouterLink as any} />;
}

export default function Breadcrumb({ orderId, orderNumber, clientId, clientName, inspectorFirmId, inspectorFirmName, formId, formName }: any) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const hash = location.hash;

  const getDisplayName = (value: string, index: number) => {
    if (hash && value.includes("Order")) {
      return decodeURIComponent(value) + hash;
    }

    if (location.state?.breadcrumb?.names?.[value]) {
      return location.state.breadcrumb.names[value];
    }

    if (value === orderId) {
      return `Order #${orderNumber}`;
    }

    if (value === clientId) {
      return clientName;
    }

    if (value === inspectorFirmId) {
      return inspectorFirmName;
    }

    if (value === formId) {
      return formName;
    }

    return (
      breadcrumbNameMap[`/${pathnames.slice(0, index + 1).join("/")}`] ||
      decodeURIComponent(value)
    );
  };

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mx: 2, mb: 1 }}>
      <LinkRouter underline="hover" color="inherit" to="/all-orders">
        <HomeOutlinedIcon style={{ height: 16, width: 16 }} />
      </LinkRouter>
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const displayName = getDisplayName(value, index);

        return last ? (
          <Typography key={to} sx={{ color: "text.primary", textTransform: "capitalize" }}>
            {displayName}
          </Typography>
        ) : (
          [
            displayName === "Orders" ? (
              <LinkRouter
                underline="hover"
                color="inherit"
                to={location.state?.breadcrumb?.ordersTo || "/all-orders"}
                key={to}
                state={{
                  ...location.state,
                  breadcrumb: location.state?.breadcrumb,
                }}
              >
                {displayName}
              </LinkRouter>
            ) : (
              <LinkRouter
                underline="hover"
                color="inherit"
                to={to}
                key={to}
                state={{
                  ...location.state,
                  breadcrumb: location.state?.breadcrumb,
                }}
              >
                {displayName}
              </LinkRouter>
            ),
          ]
        );
      })}
    </Breadcrumbs>
  );
}
